import { CompanyAttributes } from '@albatrosdeveloper/ave-models-package';
import ReturnTypeAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/return-type/return-type.entity';
import ReasonRejectionAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/masters/reason-rejection/reason-rejection.entity';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule, MatPaginatorIntl, PageEvent } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from 'app/utils/method';
import { ChangeConditionService } from './change-condition.service';
import { CompanyService } from '../../configuration/company/company.service.service';
import { ReasonRejectionService } from '../reason-for-rejection/reason-rejection.service';
import { RejectionReasonSelectorComponent } from './rejection-reason-selector/rejection-reason-selector.component';
import { FuseConfirmationService } from '@fuse/services/confirmation';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ICreateChangeConditionType, IUpdateChangeConditionType } from './interfaces/change-condition.interface';
import { IPaginationResult, IRequestResult } from 'app/common/interfaces';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ReturnTypeClassEnum, ReturnTypeOperationEnum, TypeEnum } from '@albatrosdeveloper/ave-models-package/lib/enums/return-type.enum';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ChangeConditionFiltersComponent } from '../../filters/change-condition-filters/change-condition-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";


@Component({
  selector: 'app-change-condition',
  standalone: true,
  imports: [
    CommonModule,
    MatSidenavContainer,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSlideToggle,
    MatIcon,
    MatButtonModule,
    MatMenuModule,
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatAutocompleteModule,
    FilterComponent,
    StatusFiltersComponent,
    ChangeConditionFiltersComponent,
    ConfigurationFiltersComponent,
    FormSectionComponent,
    HoverMenuDirective
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
  ],
  templateUrl: './change-condition.component.html',
  styleUrl: './change-condition.component.scss'
})
export class ChangeConditionComponent implements OnDestroy{
  getCode = getCode
  displayedColumns: string[] = [
    "name",
    //"company", 
    "class",
    "type",
    "requiresPhoto",
    "limitChange",
    "requiresApproval",
    "isLinkedToRejectedReason",
    "statusId", 
    "action"
  ];

  dataSource = new MatTableDataSource<ReturnTypeAttributes>([]);
  
  totalItems = 0
  search: string = ''
  pageSize = 50
  pageIndex: number = 1;
  sortActive: keyof ReturnTypeAttributes = "name";
  sortDirection: "ASC" | "DESC" = "ASC";

  filter = {
    class: [],
    type: null
  }

  companyList: CompanyAttributes[] = []
  companyFilterList: CompanyAttributes[] = []

  listType = Object.keys(TypeEnum)
  listClass = Object.keys(ReturnTypeClassEnum)
  listOperation = Object.values(ReturnTypeOperationEnum).filter((value): value is number => typeof value === 'number');  

  // Rejection reason properties
  rejectionReasonList: ReasonRejectionAttributes[] = [];
  filteredRejectionReasons$: Observable<ReasonRejectionAttributes[]>;
  rejectionReasonControl = new FormControl();

  currentReturnType: ICreateChangeConditionType = this.initializeCreateReturnType();
  public id: any = null

  @ViewChild("actionModal") actionModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  dialogRef: MatDialogRef<any>;
  
  //BUSCADOR
  searchSubscription: Subscription;
  selectedStatuses: []=[];

  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;
  private companiesLoaded = false;
  private rejectionReasonsLoaded = false;

  constructor(
    private changeConditionService: ChangeConditionService,
    private readonly companyService: CompanyService,
    private readonly reasonRejectionService: ReasonRejectionService,
    private readonly searchService: SearchService,
    private readonly _fuseConfirmationService: FuseConfirmationService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef
  ) {
    this.form = this.fb.group({
      companyId:[],
      changeConditionClassId: [],
      changeConditionTypeId:[]
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.onFilter();
    // Companies and rejection reasons will be loaded lazily when modal opens
  }

  onFilter(){
    this.getList()
  }

  clearFilters(): void {
      this.form = this.fb.group({
      changeConditionClassId: null,
      changeConditionTypeId:null
    });
    this.onFilter();
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
  }

  applyFilter(filterValue: string) {
    this.pageIndex = 1
    this.search = filterValue
    this.getList()
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.pageIndex = 1
        this.search = term
        this.getList()
      });
  }

  getList(): void {
    let options = { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.search, sort: this.sortActive, sortDirection: this.sortDirection }

    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      changeConditionTypeId: this.form.get("changeConditionTypeId")?.value,
      changeConditionClassId: this.form.get("changeConditionClassId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null
      
    }

    this.changeConditionService.getAllPaginateReturnType(options, filter).subscribe({
      next: (res: IPaginationResult<ReturnTypeAttributes>) => {
        this.dataSource.data = res?.data?.[0]?.data ?? [];
        this.totalItems = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener Condiciones de Cambio","Cerrar",{ duration: 5000});
      },
    })
  }

  changeSort(e) {
    this.sortActive = e.active
    this.sortDirection = e.direction?.toUpperCase() || "ASC"
    this.getList()
  }

  changePage(e: PageEvent) {
    this.pageIndex = (e.pageIndex + 1)
    this.pageSize = e.pageSize
    this.getList()
  }

  private initializeCreateReturnType(): ICreateChangeConditionType {
    return { 
      code: "", 
      externalKeys: {code: null},
      name: "", 
      requiresPhoto: false,
      requiresApproval: false,
      limitChange: false,
      company: null,
      type: null,
      class: null,
      operation: null,
      isLinkedToRejectedReason: false,
      rejectedReason: null
    };
  }

  getAllCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res: IRequestResult<CompanyAttributes[]>) => {
        this.companyList = res.data;
        this.companyFilterList = this.companyList.slice();
        this.companiesLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañia.","Cerrar",{ duration: 5000});
      }
    });
  }

  getAllRejectionReasons(): void {
    this.reasonRejectionService.findToComboBox().subscribe({
      next: (res: IRequestResult<ReasonRejectionAttributes[]>) => {
        this.rejectionReasonList = res.data;
        this.setupRejectionReasonFilter();
        this.rejectionReasonsLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener razones de rechazo.","Cerrar",{ duration: 5000});
      }
    });
  }

  setupRejectionReasonFilter(): void {
    this.filteredRejectionReasons$ = this.rejectionReasonControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRejectionReasons(value || ''))
    );
  }

  private _filterRejectionReasons(value: string): ReasonRejectionAttributes[] {
    if (typeof value === 'string') {
      const filterValue = value.toLowerCase();
      return this.rejectionReasonList.filter(reason => 
        reason.name?.toLowerCase().includes(filterValue)
      );
    }
    return this.rejectionReasonList;
  }

  displayRejectionReason(reason: ReasonRejectionAttributes): string {
    return reason && reason.name ? reason.name : '';
  }

  onToggleRejectedReason(event: MatCheckboxChange): void {
    if (!event.checked) {
      this.currentReturnType.rejectedReason = null;
      this.rejectionReasonControl.setValue(null);
    }
  }

  onRejectionReasonSelected(): void {
    const selectedReason = this.rejectionReasonControl.value;
    if (selectedReason && selectedReason._id) {
      this.currentReturnType.rejectedReason = selectedReason._id;
    } else {
      this.currentReturnType.rejectedReason = null;
    }
  }

  onLinkedToggleClick(event: MatSlideToggleChange, element: ReturnTypeAttributes): void {
   
    const originalValue = !event.source.checked;
    const newState = event.source.checked;

    event.source.checked  = originalValue;

    this.cdr.detectChanges();

    if (newState) {
      this.openReasonSelectorModal(element, event);
    } else {
      this.confirmUnlinkRejection(element, event);
    }
  }

  private openReasonSelectorModal(element: ReturnTypeAttributes, matSlideToggleChange: MatSlideToggleChange): void {
    const currentReasonId = (element as any).rejectedReason?._id || null;
    
    
    const dialogRef = this.dialog.open(RejectionReasonSelectorComponent, {
      width: '500px',
      disableClose: true,
      data: { currentReasonId }
    });

    dialogRef.afterClosed().subscribe((resultId: string) => {
      if (resultId) {
        this.updateRejectionLink(element, true, resultId, matSlideToggleChange);
      } else {
      }
    });
  }

  confirmUnlinkRejection(element: ReturnTypeAttributes, matSlideToggleChange: MatSlideToggleChange): void {
    
    const confirmation = this._fuseConfirmationService.open({
      title: 'Desvincular Razón de Rechazo',
      message: '¿Está seguro que desea desvincular esta condición? Se eliminará la relación con la razón de rechazo anterior.',
      actions: {
        confirm: { 
          label: 'Desvincular',
          color: 'warn'
        },
        cancel: { 
          label: 'Cancelar' 
        }
      }
    });

    confirmation.afterClosed().subscribe(result => {
      if (result === 'confirmed') {
        this.updateRejectionLink(element, false, null, matSlideToggleChange);
      } 
    });
  }

  updateRejectionLink(element: ReturnTypeAttributes, isLinked: boolean, rejectedReasonId: string | null, matSlideToggleChange: MatSlideToggleChange): void {
    
    const originalLinkedState = element.isLinkedToRejectedReason;
    const originalReasonData = element.rejectedReason; 
    

    const updateData: IUpdateChangeConditionType = {
      isLinkedToRejectedReason: isLinked,
      rejectedReason: isLinked ? rejectedReasonId : null
    };


    this.changeConditionService.update(element._id.toString(), updateData).subscribe({
      next: () => {
        
        element.isLinkedToRejectedReason = isLinked;
        matSlideToggleChange.source.checked = isLinked;
        
        this.snackBar.open(
          isLinked ? 'Razón de rechazo vinculada exitosamente' : 'Vínculo removido exitosamente',
          'Cerrar',
          { duration: 3000 }
        );
        this.getList();
      },
      error: (err) => {
        element.isLinkedToRejectedReason = originalLinkedState;
        element.rejectedReason = originalReasonData;
        matSlideToggleChange.source.checked = originalLinkedState;
        
        this.dataSource._updateChangeSubscription();
        
        this.snackBar.open('Error al actualizar la vinculación', 'Cerrar', { duration: 3000 });
      }
    });
  }

  getTypeLabel(type: string): string{
    const labels = {
      [TypeEnum.BE]: 'BUEN ESTADO',
      [TypeEnum.ME] : 'MAL ESTADO',
      [TypeEnum.MS] : 'MAL SELLO',
      [TypeEnum.NC] : 'NO CALIDAD'
    };
    return labels[type] || type
  }

  getClassLabel(type: string): string{
    const labels = {
      [ReturnTypeClassEnum.CP]: 'CAMBIO DE PRODUCTO',
      [ReturnTypeClassEnum.DE] : 'DEVOLUCIÓN DE PRODUCTO',
    };
    return labels[type] || type
  }

  getOperationLabel(type: number): string{
    const labels = {
      [ReturnTypeOperationEnum.EQUAL]: 'IGUAL',
      [ReturnTypeOperationEnum.INCREASE] : 'AUMENTA',
      [ReturnTypeOperationEnum.LESS] : 'DISMINUYE',
    };
    return labels[type] || type
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.getAllCompanies();
    }
  }

  private ensureRejectionReasonsLoaded(): void {
    if (!this.rejectionReasonsLoaded) {
      this.getAllRejectionReasons();
    }
  }

  openModal(returnType?: ReturnTypeAttributes): void {
    this.ensureCompaniesLoaded();
    
    if(returnType){
      const rejectedReasonId = (returnType as any).rejectedReason?._id || null;
      
      this.currentReturnType = {
        ...returnType,
        excode: returnType.externalKeys?.code ?? null,
        externalKeys: this.getCode(returnType) ? this.getCode(returnType): null,
        company: returnType.company ? returnType.company._id.toString() : "",
        isLinkedToRejectedReason: (returnType as any).isLinkedToRejectedReason || false,
        rejectedReason: rejectedReasonId  
      };
      this.id = returnType._id;
      
      this.loadRejectionReasonsForModal(rejectedReasonId);
    }else{
      this.currentReturnType = this.initializeCreateReturnType();
      this.id = null;
      this.loadRejectionReasonsForModal(null);
    }

    this.dialogRef = this.dialog.open(this.actionModal, { width: '90%', disableClose: true })
    this.dialogRef.afterClosed().subscribe((result) => { result });
  }

  private loadRejectionReasonsForModal(selectedReasonId: string | null): void {
    
    this.reasonRejectionService.findToComboBox().subscribe({
      next: (res: IRequestResult<ReasonRejectionAttributes[]>) => {
        this.rejectionReasonList = res.data;
        this.setupRejectionReasonFilter();
        
        if (selectedReasonId) {
          
          const selectedReason = this.rejectionReasonList.find(r => {
            const reasonId = r._id?.toString();
            const selectedId = selectedReasonId.toString();
            return reasonId === selectedId;
          });
          
          if (selectedReason) {
            this.rejectionReasonControl.setValue(selectedReason);
          } else {
            this.rejectionReasonControl.setValue(null);
          }
        } else {
          
          this.rejectionReasonControl.setValue(null);
        }
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener razones de rechazo por modal.","Cerrar",{ duration: 5000});
        this.rejectionReasonControl.setValue(null);
      }
    });
  }

  onSubmit(){
    if(this.id == null){
      this.createReturnType()
    }else{
      this.updateReturnType(this.id)
    }
  }

  createReturnType(): void {
    const createReturnType: ICreateChangeConditionType = { 
      ...this.currentReturnType, 
      externalKeys: this.currentReturnType.excode ? {code: this.currentReturnType.excode} : null,
      rejectedReason: this.currentReturnType.isLinkedToRejectedReason ? this.currentReturnType.rejectedReason : null
    };

    this.changeConditionService.create(createReturnType).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        if(this.dialogRef){
          this.dialogRef.close(true);
        }
        this.getList();
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateReturnType(id: string): void {
   if (this.currentReturnType) {

    const externalKeys = this.currentReturnType.excode
      ? { code: this.currentReturnType.excode }
      : undefined;

      const updatedReturnType: IUpdateChangeConditionType = { 
        externalKeys: externalKeys,
        name: this.currentReturnType.name,
        requiresPhoto: this.currentReturnType.requiresPhoto,
        requiresApproval: this.currentReturnType.requiresApproval,
        type: this.currentReturnType.type,
        class: this.currentReturnType.class,
        operation: this.currentReturnType.operation,
        company: this.currentReturnType.company, 
        isLinkedToRejectedReason: this.currentReturnType.isLinkedToRejectedReason,
        rejectedReason: this.currentReturnType.isLinkedToRejectedReason ? this.currentReturnType.rejectedReason : null
      };

      this.changeConditionService.update(id, updatedReturnType).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          if(this.dialogRef){
            this.dialogRef.close(true);
          }
          this.getList();
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, returnType: ReturnTypeAttributes, type?: string): void {
    const originalStatusId = returnType.statusId;
    const originalRequiresPhoto = returnType.requiresPhoto;
    const originalRequiresApproval = returnType.requiresApproval;
    const originalLimitChange = returnType.limitChange;

    const updatedStatusId = type == 'S' ? (event ? 1 : 0): originalStatusId;
    const updatedRequiresPhoto = type == 'F' ? event: originalRequiresPhoto;
    const updateRequiresApproval = type == 'A' ? event: originalRequiresApproval;
    const updateLimitChange = type == 'C' ? event: originalLimitChange;

    const updateReturnType = { 
      statusId: updatedStatusId,
      requiresPhoto: updatedRequiresPhoto,
      requiresApproval : updateRequiresApproval,
      limitChange: updateLimitChange,
    };

    this.changeConditionService.update(returnType._id.toString(), updateReturnType).subscribe({
      next: () => {
        this.getList();
      },
      error: () => {
        returnType.statusId = originalStatusId; 
        returnType.requiresPhoto = originalRequiresPhoto;
        returnType.requiresApproval = originalRequiresApproval;
        returnType.limitChange = originalLimitChange;

        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.getList();
      }
    });
  }

  openDeleteDialog(returnType: ReturnTypeAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: returnType, panelClass: "delete-modal", disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(returnType._id.toString()));
  }

  delete(id: string): void {
    this.changeConditionService.remove(id).subscribe(() => {
      this.getList();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
